// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getWeek as fn } from "../getWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getWeekWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getWeekWithOptions;
